import React, { Component } from 'react';
import documentSrc from 'images/document_el.svg';
import { Spinner } from 'ui';
import { hasFeatureFlags } from 'utils/features';
import { UniversalUploader } from 'components/shared/UniversalUploader';
import { routes } from 'constants/config.js';
import request from 'utils/request_ajax';
import UniversalPlayer from 'components/shared/UniversalPlayer';
import ElementBase from '../base.jsx';

class DocumentElement extends Component {
  constructor(props) {
    super(props);
    this.uploadDocument = this.uploadDocument.bind(this);
    this.saveBssUpload = this.saveBssUpload.bind(this);
    this.state = {
      hasFileUploadFF: hasFeatureFlags([
        'learning-file-stack-upload-replacement',
      ]),
      bssUploadId: this.props.content.bss_upload_id,
    };
  }

  uploadDocument() {
    const { document_id: documentId } = this.props.content;
    this.props.uploadDocument(documentId);
  }

  saveBssUpload(newUpload) {
    return new Promise(async (resolve, reject) => {
      const { document_id: documentId } = this.props.content;
      const { bssUploadId } = newUpload;
      const ERROR_MESSAGE = 'Error Uploading File';

      try {
        const { success } = await request.putJSON(
          routes.DOCUMENTS_RECORD_UPLOAD(documentId),
          {
            document: {
              bss_upload_id: bssUploadId,
            },
          },
        );
        if (!success) reject(new Error(ERROR_MESSAGE));
        this.setState({ bssUploadId });
        resolve();
      } catch (e) {
        reject(new Error(e || ERROR_MESSAGE));
      }
    });
  }

  renderUploader() {
    const { status, errorMessage } = this.props.content;
    return this.state.hasFileUploadFF ? (
      <UniversalUploader
        accept={[
          '.pdf',
          '.ppt',
          '.pptx',
          '.xls',
          '.xlsx',
          '.doc',
          '.docx',
          '.odt',
          '.odp',
          '.ods',
          '.txt',
        ]}
        onComplete={this.saveBssUpload}
        deleteUploadRecord
      />
    ) : (
      <div className="EditorElement-fileHandler">
        <div className="EditorElement-uploadArea">
          <img
            src={documentSrc}
            className="EditorElement-icon"
            alt={t('lessons.editor.elements.document')}
          />
          {!status && (
            <button
              type="button"
              onClick={this.uploadDocument}
              className="NewButton NewButton--white"
              children="Choose a Document, Presentation, or PDF to Upload"
            />
          )}
          {status === 'error' && (
            <div className="CommentForm-errorMessage">{errorMessage}</div>
          )}
          {status === 'converting' && (
            <div className="c-brand-gray">
              <Spinner className="mr-16" />
              Preparing Document - This may take a few seconds...
            </div>
          )}
        </div>
      </div>
    );
  }

  renderDocument() {
    return (
      <div className="EditorElement-fileHandler">
        <iframe
          title={t('lessons.editor.elements.document')}
          src={this.props.content.url}
          className="EditorElement-DocumentViewer"
          scrolling="false"
          frameBorder="0"
        />
      </div>
    );
  }

  renderProcessing() {
    return (
      <div className="EditorElement-fileHandler">
        <Spinner className="mr-16" />
        {t('drafts.documents_processing')}
      </div>
    );
  }

  renderUniversalPlayer() {
    const { bssUploadId } = this.state;

    return (
      <UniversalPlayer
        playerConfigEndpoint={routes.FILE_UPLOAD.BSS.PLAYER_MANIFEST(
          bssUploadId,
        )}
      />
    );
  }

  renderBody() {
    const { url, processing } = this.props.content;
    const { bssUploadId } = this.state;
    if (url && !bssUploadId) return this.renderDocument(url);
    if (bssUploadId) return this.renderUniversalPlayer();
    if (processing) return this.renderProcessing();
    return this.renderUploader();
  }

  render() {
    return <div className="EditorElement-content">{this.renderBody()}</div>;
  }
}

export default ElementBase(DocumentElement);
